
export type KeyInfo = {
  publicKeyMultibase: string,
  index: Number
};
